import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS } from "@contentful/rich-text-types";
import './section-banner-header.scss'

const SectionBannerHeader = ({ contentInfo }) => {

    const options = {
        renderNode: {
            [BLOCKS.HEADING_2]: (node, next) => <h2 className="f-m-banner-header__title">{next}</h2>,
            [BLOCKS.HEADING_1]: (node, next) => <h1 className="f-m-banner-header__subtitle">{next}</h1>
        }
    };

    return (
        <section className="f-m-banner-header">
            <div className="f-m-banner-header__content">
                <div className="f-m-banner-header__image-container">
                    <GatsbyImage
                        image={contentInfo.imagen[0].gatsbyImageData}
                        alt={contentInfo.imagen[0].description}
                        className="f-m-banner-header__image"
                    />
                </div>
                <div className="f-m-banner-header__text">
                    {contentInfo.descripcion.raw && documentToReactComponents(JSON.parse(contentInfo.descripcion.raw), options)}
                </div>
            </div>
        </section>
    )
}

export default SectionBannerHeader
